import { RequestOptionsService } from "./requestOptions";
import request from "request-promise";

export class CloudSettingService {
  public static async getCloudSettings(deviceUdid?: string) {
    const options = RequestOptionsService.getBrearerOptions(deviceUdid ? `CloudSettings/${deviceUdid}` : "CloudSettings");
    const result = await request(options);
    return result;
  }

  public static async updateCloudSetting(deviceUdid: string, setting: string, value: string) {
    const options = RequestOptionsService.postBrearerOptions(`CloudSettings/UpdateSetting?device=${deviceUdid}`, {
      key: setting[0].toUpperCase() + setting.slice(1),
      value
    });
    const result = await request(options);
    return result;
  }

  public static async updateDeviceLockStatus(deviceId: string, value: boolean) {
    const options = RequestOptionsService.postBrearerOptions("CloudSettings/UpdateLockStatus/" + deviceId, value);
    const result = await request(options).catch(r => {
      return r;
    });
    return result;
  }

  public static async cloneDevice(deviceId: string, deviceNewName: string) {
    const options = RequestOptionsService.postBrearerOptions(`CloudSettings/CloneDevice`, { deviceId, deviceNewName });
    const result = await request(options);
    return result;
  }
}
